import React, { useState } from "react";
import DashboardTopBar from "../component/DashboardTopBar";
import BookingForm from "../component/BookingForm";
import DashboardData from "../component/DashboardData";

function Dashboard() {
  const [isFormOpen, setIsFormOpen] = useState(false);

  return (
    <>
      <DashboardTopBar isFormOpen={isFormOpen} />
      {isFormOpen ? (
        <BookingForm onCancel={() => setIsFormOpen(false)} />
      ) : (
        <DashboardData onNewOrder={() => setIsFormOpen(true)} />
      )}
    </>
  );
}

export default Dashboard;
